import { createSlice } from '@reduxjs/toolkit'

export const deliveredContentSlice = createSlice({
  name: 'deliveredContent',
  initialState: {
    items : null
    
  },
  reducers: {
    loadItems: (state, action) => {
        console.log(
            'loading items'
        );
      state.items = action.payload;
    }
  }
})

export const { loadItems } = deliveredContentSlice.actions

export default deliveredContentSlice.reducer